// Numéros de service (complément 7c) — liveQuery : borne = dernière fin de
// service (max endedAt de la table sessions, cf. endServiceT1), rangs projetés
// par numerosDeService (projection PURE — aucun champ persisté, aucun schéma
// touché). Lectures via withTenant (INV-C).
import { useLiveQuery } from 'dexie-react-hooks';
import { getDb } from '@/db';
import { withTenant } from '@/db/tenant';
import { numerosDeService } from '@/lib/affichage-commande';

const VIDE: ReadonlyMap<number, number> = new Map();

export function useNumerosService(): ReadonlyMap<number, number> {
  const numeros = useLiveQuery(
    async () => {
      const sessions = await withTenant(getDb().sessions).toArray();
      const finDernierService = sessions.reduce(
        (max, s) => Math.max(max, s.endedAt ?? 0),
        0,
      );
      const commandes = await withTenant(getDb().commandes).toArray();
      return numerosDeService(commandes, finDernierService);
    },
    [],
    VIDE,
  );
  return numeros;
}
